module.exports = __webpack_public_path__ + "platform-web/static/media/security.142c066e.svg";